import ForgotPassword from './forgot_password/ForgotPassword.vue'
import Regulation from '../../views/regulation/Regulation.vue'
import { validateForm, getSlugFromRoute } from "../../../assets/js/Utils.js"
import { mapActions, mapState } from "vuex"

export default {
    components: {
        ForgotPassword,
        Regulation
    },

    props: {
        customItems: Object
    },

    data: () => ({
        validateForm,
        showPassword: false,
        form: {},
        customItemsLogin: null,
        showRegulationPrompt : false
    }),

    created(){
        window.scrollTo(0,0)
        this.customItemsLogin = this.customItems.login
        if (this.$route.params.token){
            let rawEmail = Buffer.from(this.$route.params.token, 'base64').toString()
            this.directLogin(rawEmail)
        }
    },

    methods: {
        async directLogin(login){
            const response = await this.MODULOS.client.loginOnlyEmail(login);
            if (response.status === 200) {
                sessionStorage.setItem('user', JSON.stringify({ token: response.token, id: response.cliente }) )
                await this.actionGetUser(response.cliente)
                await this.actionGetBalanceCliente()
                this.$toasted.global.success({ msg: `Bem vindo ${this.user.primeiro_nome.split(' ')[0]}!` })
                this.$router.push({ path: `/${getSlugFromRoute(this.$route.path)}` }).catch(() => document.getElementById('app').scrollIntoView())
                return
            }
        },
        async logout(){
            this.actionLogout()
            this.showRegulationPrompt = false;
            location.href = `/${this.$route.params.slug}`
            this.$toasted.global.success({ msg: "Logout realizado!" })
        },
        async acceptTerms(){ 
            localStorage.setItem("regulationAceptedAt-" + this.user.id,new Date())
            this.showRegulationPrompt = false;
            this.$router.push({ path: `/${getSlugFromRoute(this.$route.path)}` }).catch(() => document.getElementById('app').scrollIntoView())
            location.reload();
        },
        async login() {
            const resp = await this.MODULOS.client.login(this.form)
            if (resp.status === 200) {
                sessionStorage.setItem('user', JSON.stringify({ token: resp.token, id: resp.cliente }))
                await this.actionGetUser(resp.cliente)
                await this.actionGetBalanceCliente()
                console.log(this.user)
                this.$toasted.global.success({ msg: `Bem vindo ${this.user.primeiro_nome.split(' ')[0]}!` })
                if(new Date(this.establishment.data_atualizacao_regulamento) > new Date(localStorage.getItem("regulationAceptedAt-" + this.user.id))){
                    this.showRegulationPrompt = true;
                    return;
                }
                this.$router.push({ path: `/${getSlugFromRoute(this.$route.path)}` }).catch(() => document.getElementById('app').scrollIntoView())
                location.reload();
                return
            }
            this.$toasted.global.error({ msg: 'Usuario ou senha inválidos' })
        },
 
        ...mapActions(['actionGetUser','actionGetBalanceCliente','actionLogout'])
    },

    computed: {
        ...mapState(['user','establishment'])
    }
}